/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createFacilityGroup } from '../fn/facility-group/create-facility-group';
import { CreateFacilityGroup$Params } from '../fn/facility-group/create-facility-group';
import { deleteFacilityGroup } from '../fn/facility-group/delete-facility-group';
import { DeleteFacilityGroup$Params } from '../fn/facility-group/delete-facility-group';
import { FacilityDataDto } from '../models/facility-data-dto';
import { FacilityGroup } from '../models/facility-group';
import { FacilityGroupDto } from '../models/facility-group-dto';
import { FacilityGroupResponse } from '../models/facility-group-response';
import { getFacilityData } from '../fn/facility-group/get-facility-data';
import { GetFacilityData$Params } from '../fn/facility-group/get-facility-data';
import { getFacilityGroupHarvests } from '../fn/facility-group/get-facility-group-harvests';
import { GetFacilityGroupHarvests$Params } from '../fn/facility-group/get-facility-group-harvests';
import { getFacilityGroupsByCustomer } from '../fn/facility-group/get-facility-groups-by-customer';
import { GetFacilityGroupsByCustomer$Params } from '../fn/facility-group/get-facility-groups-by-customer';
import { getOverviewFacility } from '../fn/facility-group/get-overview-facility';
import { GetOverviewFacility$Params } from '../fn/facility-group/get-overview-facility';
import { getOverviewFacilityGroup } from '../fn/facility-group/get-overview-facility-group';
import { GetOverviewFacilityGroup$Params } from '../fn/facility-group/get-overview-facility-group';
import { getOverviewZonesFacility } from '../fn/facility-group/get-overview-zones-facility';
import { GetOverviewZonesFacility$Params } from '../fn/facility-group/get-overview-zones-facility';
import { getZoneTargets } from '../fn/facility-group/get-zone-targets';
import { GetZoneTargets$Params } from '../fn/facility-group/get-zone-targets';
import { Harvest } from '../models/harvest';
import { HarvestTargetResponse } from '../models/harvest-target-response';
import { OverviewFacilityDto } from '../models/overview-facility-dto';
import { OverviewZoneDto } from '../models/overview-zone-dto';
import { updateFacilityGroup } from '../fn/facility-group/update-facility-group';
import { UpdateFacilityGroup$Params } from '../fn/facility-group/update-facility-group';
import { ZonesOverviewResponse } from '../models/zones-overview-response';

@Injectable({ providedIn: 'root' })
export class FacilityGroupService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFacilityGroupsByCustomer()` */
  static readonly GetFacilityGroupsByCustomerPath = '/api/facilitygroup';

  /**
   * Get Facility Groups By Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityGroupsByCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupsByCustomer$Response(params?: GetFacilityGroupsByCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupDto>>> {
    return getFacilityGroupsByCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Groups By Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityGroupsByCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupsByCustomer(params?: GetFacilityGroupsByCustomer$Params, context?: HttpContext): Observable<Array<FacilityGroupDto>> {
    return this.getFacilityGroupsByCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityGroupDto>>): Array<FacilityGroupDto> => r.body)
    );
  }

  /** Path part for operation `createFacilityGroup()` */
  static readonly CreateFacilityGroupPath = '/api/facilitygroup';

  /**
   * Create Facility Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFacilityGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacilityGroup$Response(params: CreateFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupResponse>> {
    return createFacilityGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Facility Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFacilityGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacilityGroup(params: CreateFacilityGroup$Params, context?: HttpContext): Observable<FacilityGroupResponse> {
    return this.createFacilityGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupResponse>): FacilityGroupResponse => r.body)
    );
  }

  /** Path part for operation `getOverviewFacility()` */
  static readonly GetOverviewFacilityPath = '/api/facilitygroup/overview/facilityId/{facilityId}';

  /**
   * Get Overview Facility.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewFacility()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewFacility$Response(params: GetOverviewFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OverviewZoneDto>>> {
    return getOverviewFacility(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Overview Facility.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewFacility$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewFacility(params: GetOverviewFacility$Params, context?: HttpContext): Observable<Array<OverviewZoneDto>> {
    return this.getOverviewFacility$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OverviewZoneDto>>): Array<OverviewZoneDto> => r.body)
    );
  }

  /** Path part for operation `getOverviewZonesFacility()` */
  static readonly GetOverviewZonesFacilityPath = '/api/facilitygroup/overview/zones/facilityId/{facilityId}';

  /**
   * Get Overview Zones Facility.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewZonesFacility()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewZonesFacility$Response(params: GetOverviewZonesFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<ZonesOverviewResponse>> {
    return getOverviewZonesFacility(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Overview Zones Facility.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewZonesFacility$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewZonesFacility(params: GetOverviewZonesFacility$Params, context?: HttpContext): Observable<ZonesOverviewResponse> {
    return this.getOverviewZonesFacility$Response(params, context).pipe(
      map((r: StrictHttpResponse<ZonesOverviewResponse>): ZonesOverviewResponse => r.body)
    );
  }

  /** Path part for operation `getZoneTargets()` */
  static readonly GetZoneTargetsPath = '/api/facilitygroup/overview/zones/targets/{facilityId}';

  /**
   * Get Zone Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getZoneTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZoneTargets$Response(params: GetZoneTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestTargetResponse>>> {
    return getZoneTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zone Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getZoneTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZoneTargets(params: GetZoneTargets$Params, context?: HttpContext): Observable<Array<HarvestTargetResponse>> {
    return this.getZoneTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestTargetResponse>>): Array<HarvestTargetResponse> => r.body)
    );
  }

  /** Path part for operation `getOverviewFacilityGroup()` */
  static readonly GetOverviewFacilityGroupPath = '/api/facilitygroup/overview/{facilityGroupId}';

  /**
   * Get Overview Facility Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewFacilityGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewFacilityGroup$Response(params: GetOverviewFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OverviewFacilityDto>>> {
    return getOverviewFacilityGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Overview Facility Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewFacilityGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewFacilityGroup(params: GetOverviewFacilityGroup$Params, context?: HttpContext): Observable<Array<OverviewFacilityDto>> {
    return this.getOverviewFacilityGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OverviewFacilityDto>>): Array<OverviewFacilityDto> => r.body)
    );
  }

  /** Path part for operation `updateFacilityGroup()` */
  static readonly UpdateFacilityGroupPath = '/api/facilitygroup/{facilityGroupId}';

  /**
   * Update Facility Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFacilityGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityGroup$Response(params: UpdateFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupResponse>> {
    return updateFacilityGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Facility Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFacilityGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityGroup(params: UpdateFacilityGroup$Params, context?: HttpContext): Observable<FacilityGroupResponse> {
    return this.updateFacilityGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupResponse>): FacilityGroupResponse => r.body)
    );
  }

  /** Path part for operation `deleteFacilityGroup()` */
  static readonly DeleteFacilityGroupPath = '/api/facilitygroup/{facilityGroupId}';

  /**
   * Delete Facility Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFacilityGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityGroup$Response(params: DeleteFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroup>> {
    return deleteFacilityGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Facility Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFacilityGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityGroup(params: DeleteFacilityGroup$Params, context?: HttpContext): Observable<FacilityGroup> {
    return this.deleteFacilityGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroup>): FacilityGroup => r.body)
    );
  }

  /** Path part for operation `getFacilityGroupHarvests()` */
  static readonly GetFacilityGroupHarvestsPath = '/api/facilitygroup/{facilityGroupId}/harvest';

  /**
   * Get Facility Group Harvests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityGroupHarvests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupHarvests$Response(params: GetFacilityGroupHarvests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Harvest>>> {
    return getFacilityGroupHarvests(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Group Harvests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityGroupHarvests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupHarvests(params: GetFacilityGroupHarvests$Params, context?: HttpContext): Observable<Array<Harvest>> {
    return this.getFacilityGroupHarvests$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Harvest>>): Array<Harvest> => r.body)
    );
  }

  /** Path part for operation `getFacilityData()` */
  static readonly GetFacilityDataPath = '/api/facilitygroup/{facilityGroupId}/harvestfacility';

  /**
   * Get Facility Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityData$Response(params: GetFacilityData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityDataDto>>> {
    return getFacilityData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityData(params: GetFacilityData$Params, context?: HttpContext): Observable<Array<FacilityDataDto>> {
    return this.getFacilityData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityDataDto>>): Array<FacilityDataDto> => r.body)
    );
  }

}
